<template>
  <div id="adesao-aviseme">
    
    <Header :home="false" :logged="logged" :arealogada="true"/>
    <modalvalidaemail :key="'modalvalidaemail-'+keyModalValidaEmail" :tipo="'aviseme'" @cancelaValidacaoEmail="cancelaValidacaoEmail" @confirmaValidacaoEmail="confirmaValidacaoEmail"/>
    <b-modal
      ref="confirmaSemCertificado"
      size="x1"
      title="Atenção"
      @ok="redirecionaPainel"
      no-close-on-backdrop
      no-close-on-esc
    >
      <template #modal-header="">
        <h5>Atenção</h5>
      </template>
      Para utilizar o serviço de Avise-me é necessário estar logado por meio de Certificado Digital ICP-Brasil ou niveis Prata ou Ouro via acesso .GOV.BR
    </b-modal>
    <b-modal ref="modalTermo" id="modalTermo"
        :title="modalTermo.titulo"
        :hide-header-close="true"
        :no-close-on-esc="true"
        :no-close-on-backdrop="true"
        hide-footer>
      <p v-html="modalTermo.texto"/>
      <div class="d-flex justify-content-between mt-5">
        <b-button class="modal-btn-voltar" @click="cancelaTermo">Cancelar</b-button>
        <b-button class="modal-btn-prosseguir" @click="confirmaTermo">Confirmar</b-button>
      </div>
    </b-modal>
    <b-modal ref="erroPush" id="erroPushModal"
        title="Atenção"
        :hide-header-close="true"
        :no-close-on-esc="true"
        :no-close-on-backdrop="true"
        hide-footer>
      <p>{{this.erroPushMsg}}</p>
      <div class="d-flex justify-content-between mt-5">
        <b-button class="modal-btn-voltar" @click="cancelaErroPush">Voltar ao Painel</b-button>
        <b-button class="modal-btn-prosseguir" @click="confirmaErroPush">Prosseguir</b-button>
      </div>
    </b-modal>
    <a id="download_termo_aviseme" download="termo_aviseme" style="display: none" />
    <a id="download_termo_site" download="termo_site" style="display: none" />
    <div id="painel" class="container-fluid">
      <b-row>
        <b-col cols="12" md="4" lg="3" style="padding: 0;" class="espaco-menu">
          <Menu class="d-none d-xl-block" />
        </b-col>
        <b-col cols="12" md="8" lg="9" class="flex" style="padding: 0;">
          <b-container fluid id="painelcontainerfluid">
            <b-form name="frmProcuracao" id="frmProcuracao">
              <h4 class="text-primary mt-5 text-center"><b>Avise-me! - Adesão</b></h4>
              <br>
              <br>
              <div class="text-center" v-if="loading" style="
                  background: rgba(255, 255, 255, 0.7) none repeat scroll 0% 0%;
                  width: 100%;
                  height: 100%;
                  position: absolute;
                  display: block;
                  z-index: 10002;
                  margin: 0;
                  top: 0;
                  padding-top: 20%;
                ">
                <b-spinner variant="primary" style="width: 3rem; height: 3rem" label="Text Centered"></b-spinner>
                <br /> 
                <span style="color: #004e86">Processando Aguarde...</span>
              </div>
              <b-tabs content-class="mt-3" align="center" class="ul-ieptb">
                <h3 class="card-ieptb mb-5">Termos de uso</h3>
                  <div class="mb-4">
                    <div 
                      class="card-termo d-flex align-items-center justify-content-between pr-4 pl-4"
                      :class="(termos.aviseme.confirmado ? 'checked':'') + (formBlocked?' disabled' : '')"
                    >
                      <div class="termo-check"
                        @click="toggleTermo('ic_download_termo_aviseme')"
                      >
                        <b-form-checkbox 
                          v-model="ic_download_termo_aviseme"
                          :disabled="termos.aviseme.confirmado || formBlocked"
                          @input="checkTermo('aviseme')"
                          size="lg"
                        >
                          <span><b>Termos de uso do AVISE-ME</b></span>
                        </b-form-checkbox>
                      </div>
                      <b-button
                        class="btn-download-aviseme"
                        @click="download_termo_aviseme"
                      >
                        <div class="btn-content">
                          <span>Download</span>
                        </div>
                      </b-button>
                    </div>
                  </div>
                  <hr size="1" class="mt-5 mb-5 d-block d-md-none" style="border:1px dashed #597EB5 ;">
                  <div class="mb-4">
                    <div 
                      class="card-termo d-flex align-items-center justify-content-between pr-4 pl-4"
                      :class="(termos.site.confirmado ? 'checked':'') + (formBlocked?' disabled' : '')"
                    >
                      <div class="termo-check"
                        @click="toggleTermo('ic_download_termo_site')"
                      >
                        <b-form-checkbox 
                          v-model="ic_download_termo_site"
                          :disabled="termos.site.confirmado || formBlocked"
                          @input="checkTermo('site')"
                          size="lg"
                        >
                          <span><b>Termos de uso do SITE</b></span>
                        </b-form-checkbox>
                      </div>
                      <b-button
                        class="btn-download-aviseme"
                        @click="download_termo_site"
                      >
                        <div class="btn-content">
                          <span>Download</span>
                        </div>
                      </b-button>
                    </div>
                  </div>
                  <div class="mb-4">
                    <h5 class="card-ieptb">Documento número: <b>{{ usuario_logado | formata_documento}}</b></h5>
                    <hr>
                  </div>
                  <div class="mb-4">
                    <b-card-text class="card-ieptb">
                      Quero receber
                      <h4 class="card-ieptb"><b>os avisos por:</b></h4>
                    </b-card-text>
                    <div id="aviseme-selection">
                      <b-form-group>
                        <b-form-checkbox
                          v-for="option in avisemeOptions"
                          class="card-aviseme-selection" 
                          :class="(avisemeSelected.includes(option.value)?'selected':'') + (option.disabled?' disabled':'')"
                          v-model="avisemeSelected"
                          :key="option.value"
                          :value="option.value"
                          size="lg"
                          switch
                          :disabled="option.disabled"
                        >
                          <div class="d-flex justify-content-center" style="width:fit-content;margin-left:16px;">
                            <img
                              :src="getSVGIcon(option.icon + (avisemeSelected.includes(option.value)?'_white':''))"
                              :style="'width: 40px;height: 40px;' + option.iconStyle " />
                          </div>
                          <span>{{option.text}}</span>
                        </b-form-checkbox>
                      </b-form-group>
                    </div>
                  </div>
                  <div class="d-flex justify-content-center align-items-center mb-5 mt-5">
                    <span class="card-ieptb" style="width:250px;">
                      O <b>serviço será suspenso</b> caso nenhuma opção esteja selecionada
                    </span>
                    <b-button class="ml-5 mr-5" variant="success" size="lg" :disabled="formBlocked || invalidSelection" @click="aceita_adesao_aviseme">Aceitar</b-button>
                  </div>
                </b-tabs>
            </b-form>
          </b-container>
        </b-col>
      </b-row>
    </div>
    <footersite class="d-none d-xl-block" />
    <footersitemobile class="d-block d-xl-none"/>
  </div>
</template>

<script>
  import Header from '../../components/Header'
  import API from '../../services/api'
  import Menu from '../../template/Menu'
  import footersite from "@/components/footersite";
  import footersitemobile from "@/components/footersite/index_mobile";
  
  import modalvalidaemail from "@/components/modal/valida-email";


  //import Modal from '../../components/modal/Confmodal'


  export default {
    components: {
        Header,
        Menu,
        footersite,
        footersitemobile,
        modalvalidaemail,
      //Modal,
    },
    data() {
      return {
        loading:true,
        usuario_logado: localStorage.getItem("usrCpf"),
        logged: "",
        usuario:{},
        ic_download_termo_aviseme:false,
        ic_download_termo_site:false,
        avisemeOptions:{
          ic_aviseme_email:{text:'E-mail',value:'ic_aviseme_email',disabled:false,icon:'envelope_icon',iconStyle:'',type:'email',},
          ic_aviseme_sms: {text:'SMS',value:'ic_aviseme_sms',disabled:false,icon:'sms_icon',iconStyle:'margin-top:-9px',type:'sms',},
          // ic_aviseme_wpp: {text:'WhatsApp',value:'ic_aviseme_wpp',disabled:false,icon:'whatsapp_logo',iconStyle:'',type:'wpp',},
        },
        avisemeSelected:['ic_aviseme_email'],
        erroPushMsg: '',
        erroPushRoute: {name:'painel'},
        formBlocked: true,
        invalidSelection:false,
        termos:{
          aviseme:{
            confirmado:false,
            texto:`Declaro que li e ACEITO o TERMO de ADESÃO em todos os seus termos e que AUTORIZO e tenho CIÊNCIA que a intimação
                    do protesto poderã ser entregue por portador do(s) cartório(s) ou, alternativamente, por e-mail ou por SMS, 
                    conforme os dados fornecidos no cadastro e de acordo com autorização dada no item III letras "b" e "c", do TERMO DE ADESÃO`
          },
          site:{
            confirmado:false,
            texto:`Para acessar o AVISE-ME, também é preciso aceitar o <b>TERMO DE ADESÃO e USO da CENPROT e assiná-lo digitalmente.</b>
                <br>
                <br>
                Declaro que li e ACEITO o TERMO DE ADESÃO E USO da CENPROT em todos os seus termos.`
          },
        },
        modalTermo:{
          titulo:'',
          texto:'',
          selected:'',
        },
        keyModalValidaEmail:0,
      }
    },
    filters: {
      formata_documento: function (value){
        return value.length == 11 ? value.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4') : value.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5')
      }
    },
    methods: {
      getSVGIcon(icon) {
        var images = require.context('../../assets/imgs/svg/', false, /\.svg$/)
        return images('./' + icon + ".svg")
      },
      async getDados() {
        const token = localStorage.getItem("jwtToken");
        const res = await API.get(`usuario/logado?token=${token}`);

        this.usuario.nome = res.data[0].nm_usuario;
        this.usuario.cpf_cnpj = res.data[0].nm_nr_cpfcnpj;
        this.usuario.celular = res.data[0].nm_nr_celular;
        this.usuario.telefone = res.data[0].nm_nr_telefone;
        this.usuario.email = res.data[0].nm_email;
        this.usuario.ic_email_validado = res.data[0].ic_email_validado;
        this.usuario.nm_email_atual = res.data[0].nm_email;
      },
      async download_termo_aviseme (){
        const token = localStorage.getItem("jwtToken");
        API.post("usuario/download_termo_aviseme", { token }).then((res) => {
          this.ic_download_termo_aviseme = res.data.situacao == 1 ? true : false;
          this.termos.aviseme.confirmado = this.ic_download_termo_aviseme;
          // let dlnk = document.getElementById("download_termo_aviseme");
          // dlnk.href = "data:application/pdf;base64," + res.data.pdf;
          // dlnk.click();

          const base64String = res.data.pdf; // your base64 string here
          const byteCharacters = atob(base64String);
          const byteNumbers = new Array(byteCharacters.length);
          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          const byteArray = new Uint8Array(byteNumbers);
          const blob = new Blob([byteArray], { type: 'application/pdf' });
          const blobUrl = URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = blobUrl;
          link.download = 'download_termo_aviseme.pdf'; // the name of the file to download
          link.click();

        }).catch((err) => {
          this.ic_download_termo_aviseme = false;
          alert("Erro ao confirmar os termos do AVISE-ME!")
        });
      },

      async download_termo_site (){
        const token = localStorage.getItem("jwtToken");
        API.post("usuario/download_termo_site", { token }).then((res) => {
          this.ic_download_termo_site = res.data.situacao == 1 ? true : false;
          this.termos.site.confirmado = this.ic_download_termo_site;
          // let dlnk = document.getElementById("download_termo_site");
          // dlnk.href = "data:application/pdf;base64," + res.data.pdf;
          // dlnk.click();

          const base64String = res.data.pdf; // your base64 string here
          const byteCharacters = atob(base64String);
          const byteNumbers = new Array(byteCharacters.length);
          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          const byteArray = new Uint8Array(byteNumbers);
          const blob = new Blob([byteArray], { type: 'application/pdf' });
          const blobUrl = URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = blobUrl;
          link.download = 'download_termo_site.pdf'; // the name of the file to download
          link.click();

        }).catch((err) => {
          this.ic_download_termo_site = false;
          alert("Erro ao confirmar os termos do SITE!")
        });
      },
      async aceita_adesao_aviseme(){
        if(!this.formBlocked){
          const {
            token = localStorage.getItem("jwtToken"),
            ic_aviseme_email = false,
            ic_aviseme_sms = false,
            // ic_aviseme_wpp = false
          } = this.avisemeSelected.reduce((acc, item) => ({ ...acc, [item]: true }), {})
          let adesao = {
            token: token,
            ic_aviseme_email: ic_aviseme_email,
            ic_aviseme_sms: ic_aviseme_sms,
            // ic_aviseme_wpp: ic_aviseme_wpp
          };
          const res = await API.post("usuario/aceita_adesao_aviseme", adesao)
          if(res.data.situacao == true)this.$router.push({name:'avise-me'})
        }
      },
      confirmaErroPush(){
        this.$refs['erroPush'].hide();
        this.$bvModal.show("modal-valida-email");
        // this.erroPushRoute = {name:'cadastroUser'};
        // this.$router.push(this.erroPushRoute);
      },    
      cancelaErroPush(){
        this.$router.push(this.erroPushRoute);
      },
      toggleTermo(termo){
        this[termo] = !this[termo];
      },
      async checkTermo(termo){
        this.modalTermo.titulo = 'Termo de uso do ';
        switch (termo) {
          case 'aviseme': 
            this.modalTermo.titulo += 'AVISE-ME';
            this.modalTermo.selected = 'ic_download_termo_aviseme'
            break;
          case 'site': 
            this.modalTermo.titulo += 'SITE';
            this.modalTermo.selected = 'ic_download_termo_site'
            break;
        }
        this.modalTermo.texto = this.termos[termo].texto;
        if(this.termos[termo].confirmado) this[this.modalTermo.selected] = true;
        else{
          if(this[this.modalTermo.selected]){
            this.$refs['modalTermo'].show();
          }
        }
      },
      confirmaTermo(){
        switch (this.modalTermo.selected) {
          case 'ic_download_termo_aviseme': this.download_termo_aviseme();break;
          case 'ic_download_termo_site': this.download_termo_site();break;
        }
        this.$refs['modalTermo'].hide();
      },    
      cancelaTermo(){
        this[this.modalTermo.selected] = false;
        this.$refs['modalTermo'].hide();
      },
      unBlockForm(){
        const form = document.getElementById('adesao-aviseme');
        if (form) {
          const elementsToDisable = form.querySelectorAll('input, select, textarea, button, a');
          elementsToDisable.forEach(element => {element.disabled = false;});
        }
        Object.values(this.avisemeOptions).forEach(e => {e.disabled = false;});
        this.formBlocked = false;
      },
      blockForm(){
        const form = document.getElementById('adesao-aviseme');
        if (form) {
          const elementsToDisable = form.querySelectorAll('input, select, textarea, button, a');
          elementsToDisable.forEach(element => {element.disabled = true;});
        }
        Object.values(this.avisemeOptions).forEach(e => {e.disabled = true;});
        this.formBlocked = true;
      },
      cancelaValidacaoEmail(acao){
        if(acao){
          this.redirecionaPainel();
        }
      },
      confirmaValidacaoEmail(acao){
        if(acao){
          this.keyModalValidaEmail++;
          this.unBlockForm();
        }
      },
      redirecionaPainel(){
        this.$router.push({name: "painel"});
      },
    },
    async created(){
      let self = this;

      self.loading = true;
      let loginComCertifiicado = 
        localStorage.getItem("sg_tipo_documento") && 
        localStorage.getItem("SSL_CLIENT_S_DN_CN") && 
        localStorage.getItem("nm_tipo_certificado") &&
        localStorage.getItem("SSL_CLIENT_S_DN") &&
        localStorage.getItem("SSL_CLIENT_V_START") &&
        localStorage.getItem("SSL_CLIENT_V_END");

      let govLogin = (localStorage.getItem('pxppwiru9') != undefined && localStorage.getItem('pxppwiru9') != null);
      let allowedGov = (govLogin ? ['2','3'].includes(localStorage.getItem("lhwvzhds3")) : false)
    
      setTimeout(function (){
        if((!govLogin || !allowedGov) && !loginComCertifiicado){
          self.$refs["confirmaSemCertificado"].show();
          self.loading = false;
        }
      },1)

      let dados = await self.getDados();
      setTimeout(() => {
        if(self.usuario.ic_email_validado != 1){
            self.blockForm();
            self.loading = false;
            self.erroPushMsg = 'Para prosseguir com essa ação é necessário que seu e-mail esteja validado. Deseja prosseguir para a validação ou voltar para a página inicial?';
            self.$refs['erroPush'].show();
        }
        else{
          const token = localStorage.getItem("jwtToken");
          API.post("usuario/getPermicaoServico", { token }).then((res) =>{
            this.ic_download_termo_aviseme  = res.data[0].ic_download_termo_aviseme ? true : false
            this.ic_download_termo_site     = res.data[0].ic_download_termo_site    ? true : false
            this.termos.aviseme.confirmado = this.ic_download_termo_aviseme;
            this.termos.site.confirmado = this.ic_download_termo_site;
          })
          this.$root.isLogged().then(() => {
            this.logged = true;
            self.formBlocked = false;
            self.loading = false;
          }).catch(() => {
              self.blockForm();
              this.logged = false;
              self.loading = false;
          });
        }
      }, 10);
    },
    watch: {
      avisemeSelected(newValue) {
        this.invalidSelection = newValue.length === 0;
      },
    },
  }
</script>

<style scoped>
#painel .tab2-protesto h4{font: normal normal bold 30px/30px 'Kanit', sans-serif;}
#painel .tab2-protesto label{font: normal normal normal 15px/20px 'Kanit', sans-serif;}
#wrapper-spinner {
position: absolute;
left: 0px;
bottom: 0px;
width: 100%;
height: calc(100% - 80px);
}
#wrapper-spinner .v-spinner {
position: absolute;
left: 50%;
top: 50%;
margin: -10px 0px 0px -20px;
}
  
#painel {
position: fixed;
width: 100%;
left: 0px;
bottom: 0px;
padding-top: 0px;
height: calc(100% - 80px);
overflow-x: hidden;
  border-top: 1px solid #f1f1f1;
}
  .lista-certidoes {
      color: #000;
  }
  .lista-certidoes b {
      font-size: 0.85rem;
      color: var(--main-azul);
  }

  a {
      color: #555;
  }
  .shadow {
      box-shadow: 0 .5rem 1rem rgba(0, 0, 0, .15) !important;
  }
  #loading-solicitante {
      vertical-align: 0;
      margin-left: -21px;
  }
  @keyframes loading{
      100%{
          transform: rotate(360deg)
      }
  }
  .bold{
  font-weight: bold;
  }
  .mensagemErro{
    color: red;
  }
  #cabecalho{
    z-index: 0 !important;
  }
  
#painel > .row{justify-content: space-between;}

#painel{scrollbar-width:none;}
#painel::-webkit-scrollbar{display:none;}
.espaco-menu{width: calc(296px + 5px + 5px);flex: unset;margin-left: calc(3.8vw - 5px);}
#painel h1 {text-align: left;font: normal normal bold 30px/41px 'Kanit', sans-serif; letter-spacing: 0px;color: #597EB5;margin-bottom: 33px;}

#painelcontainerfluid{padding:0;padding-bottom: 52px;padding-right: 3.8vw;margin-top: 37px;}
@media (max-width:1600px) and (min-width:1400px){
.espaco-menu{margin-left: calc(20px - 5px) !important;}  
#painelcontainerfluid{padding-right: 20px !important;}
}
@media (max-width:1399px) and (min-width:1200px){
.espaco-menu{margin-left: calc(10px - 5px) !important;}
#painelcontainerfluid{padding-right: 10px !important;}
}

@media (max-width:1199px){
#painel {padding:0 17px;}
#painel > .row{
  width: 100%;
  max-width: none;
  margin: 0 !important;
  padding: 0px !important;
  margin-bottom: 70px !important;
}
.col-lg-9{max-width: none;flex: 1 1 100%;}
#painelcontainerfluid{padding:0px !important;}
}
#aviseme-selection fieldset div{
display:flex;
flex-wrap:wrap;
gap: 2%;
}
#aviseme-selection .card-aviseme-selection{
display:flex;
flex: 1 1 32%;
max-width: 32%;
min-width: 260px;
border-radius:5px;
border: 3px solid #597EB5;
align-items: center;
gap: 8px;
margin-bottom: 15px;
transition:all 0.25s ease-in-out;
cursor: pointer;

padding: 0;
height:90px;
}
#aviseme-selection .card-aviseme-selection *{
user-select: none; 
}
#aviseme-selection .card-aviseme-selection:hover{
box-shadow: 2px 4px 8px 0px #00000075;
}

#aviseme-selection .card-aviseme-selection span{
transition:all 0.25s ease-in-out;
text-align: left;
font: normal normal bold 18px/18px 'Kanit', sans-serif;
letter-spacing: 0px;
color: #597EB5;

margin-left: 8px;
}
#aviseme-selection .card-aviseme-selection.selected{
background-color: #4780f1;
border-color: #4780f1 ;
}
#aviseme-selection .card-aviseme-selection.disabled{
border-color: #c3c3c3;
cursor:unset;
}
#aviseme-selection .card-aviseme-selection.disabled span{
color:#c3c3c3;
}
#aviseme-selection .card-aviseme-selection.selected.disabled{
background-color: #c3c3c3;
}
#aviseme-selection .card-aviseme-selection.disabled:hover{
box-shadow:none;
}
#aviseme-selection .card-aviseme-selection.selected span{
color:#FFFFFF;
}

#modalTermo p,
#erroPushModal p{
text-align: left;
font: normal normal normal 15px/20px 'Kanit',sans-serif;
letter-spacing: 0px;
}
#modalTermo button,
#erroPushModal button{
text-align: left;
font: normal normal bold 15px/18px 'Kanit', sans-serif;
letter-spacing: 0px;
height: 48px;
}
#modalTermo .modal-btn-voltar,
#erroPushModal .modal-btn-voltar {
border:none;
background-color: #FFFFFF;
border: 3px solid transparent;
color: #4780f1;
}
#modalTermo .modal-btn-voltar:hover,
#erroPushModal .modal-btn-voltar:hover{
border: 3px solid #4780f1;
}
#modalTermo .modal-btn-prosseguir,
#erroPushModal .modal-btn-prosseguir{
border: 3px solid #597EB5;
background: #ffffff;
color: #597EB5;
}
#modalTermo .modal-btn-prosseguir:hover,
#erroPushModal .modal-btn-prosseguir:hover{
border: 3px solid #4780f1;
background: #4780f1;
color: #ffffff;

}

.btn-download-aviseme{
background-color: #4780f1f0;
height:96px;
width:285px;
display:flex;
align-items:center;
border:none;
padding:0;
border-radius:5px;
}
.btn-download-aviseme:hover{
background-color: #4780f1e0;
border-radius:5px;
}
.btn-download-aviseme .btn-content{
width: 100%;
height: 100%;
display: flex;
align-items:center;
justify-content:center;
}
.btn-download-aviseme .btn-content span{
text-align: left;
font: normal normal bold 20px/20px 'Kanit', sans-serif;
letter-spacing: 0px;
width:180px;
text-align:center;
padding: 21px 0px;
}
.btn-download-aviseme .btn-content:after{
content:'\f0ed';
width:96px;
height:96px;
font-family: 'Font Awesome 5 Free';
font-size: 33px;
font-weight: 600;
color:#FFFFFF;
padding: 15px 17.5px;
background-color:#4780f1;
border-radius: 0px 8px 8px 0px;
display:flex;
align-items:center;
justify-content:center;
}


.btn-download-aviseme:disabled{
opacity: 1;
background-color: #c3c3c3cd;
}
.btn-download-aviseme:disabled .btn-content:after{
background-color: #c3c3c3;
}
.card-termo{
/* border: 3px solid #597EB5; */
/* padding: 30px 20px; */
/* cursor:pointer; */
}
.card-termo.disabled{
cursor:default;
}
.card-termo *{user-select:none;}
.termo-check{
border: 3px solid #4780f1;
padding: 30px 20px;
cursor:pointer;
width:100%;
margin-right: 30px;
}
.card-termo.disabled .termo-check{
border-color:#c3c3c3;
opacity:0.8;
}
.card-termo.checked .termo-check{
background-color:#4780f1;
border-color:#4780f1;
cursor:default;
}

.card-termo.checked.disabled .termo-check{
border-color:#c3c3c3;
background-color:#c3c3c3;
}

.card-termo.disabled{
/* border-color: #c3c3c3; */
/* opacity:0.8; */
}

@media (max-width: 910px){
#aviseme-selection .card-aviseme-selection{
  flex: 1 1 100%;
  max-width: 100%;
}
.card-termo{
  flex-flow:column;
  padding: 0px !important;
  background: none;
  border: none;
}
.btn-download-aviseme{
  width:100%;
  height: 100px;
  border-radius: 0;
}

.btn-download-aviseme .btn-content span{
  width: calc(100% - 100px);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size:22px;
}
.btn-download-aviseme .btn-content::after{
  width: 100px;
  height: 100px;
  border-radius:0px;
  display:flex;
  align-items:center;
  justify-content:center;
  font-size:30px;
}
.termo-check{
  display:flex;
  justify-content:center;
  align-items:center;
  width:100%;
  height: 100px;
  border: 3px solid #4780f1;
  margin:0;
  margin-bottom: 10px;
}
.card-termo.checked .termo-check{
  background: #4780f1;
}
.card-termo.disabled .termo-check{
  border-color: #c3c3c3;
  opacity:0.8;
}
.card-termo.checked.disabled .termo-check{
  background: #c3c3c3;
}
}
</style>
